// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width {
  width: 100%;
}

.form {
  min-width: 300px;
  max-width: 300px;
  width: 100%;
}

.mat-active {
  background-color: #0078d7;
  font-weight: bold;
  color: white;
  right: 0;
}

.mat-noactive {
  background-color: white;
  font-weight: bold;
  color: #0078d7;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/users/edit-user/reports-list/report-dialog/report-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAGA;EACE,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,QAAA;AAAF;;AAGA;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,QAAA;AAAF","sourcesContent":[".full-width {\r\n  width: 100%;\r\n}\r\n\r\n.form {\r\n  min-width: 300px;\r\n  max-width: 300px;\r\n  width: 100%;\r\n}\r\n\r\n\r\n.mat-active{\r\n  background-color: #0078d7;\r\n  font-weight:bold;\r\n  color:white; \r\n  right:0;\r\n}\r\n\r\n.mat-noactive{\r\n  background-color: #ffff;\r\n  font-weight:bold;\r\n  color:#0078d7; \r\n  right:0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
